module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "background-01"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-right": ""
    }
  }, [_c('v-flex', {
    staticClass: "animated fadeInUp dura_1",
    attrs: {
      "xs12": "",
      "sm9": ""
    }
  }, [_c('ui-title-one', {
    attrs: {
      "titleAccess": "¿Qué es el ingreso?",
      "titleLevel": "h1"
    }
  }, [_c('template', {
    slot: "partOne"
  }, [_vm._v("¿Qué es "), _c('br')]), _vm._v(" "), _c('template', {
    slot: "partThree"
  }, [_vm._v(" el ingreso?")])], 2)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "hidden-xs-only ",
    attrs: {
      "xs12": "",
      "sm2": "",
      "text-xs-right": ""
    }
  }, [_c('image-app', {
    staticClass: "animated fadeInRight",
    attrs: {
      "imaSize": 250,
      "imaSrc": "design/banco1-1-3-2",
      "imaAlt": ""
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('ui-simple-lsc', {
    attrs: {
      "vidTittle": '¿Qué es el ingreso?',
      "videoEmbed": "ADMINISTRACIONDINERO19QueEsIngreso (50).mp4"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "animated fadeIn dura_2",
    attrs: {
      "xs12": "",
      "sm5": "",
      "md5": "",
      "text-xs-center": ""
    }
  }, [_c('image-app', {
    staticClass: "animated fadeInLeft",
    attrs: {
      "imaSize": 350,
      "imaSrc": "contenido/diapositiva_20",
      "imaAlt": "Persona sosteniendo en la mano sus ingresos"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "animated fadeInUp dura_2 aligner",
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('p', {
    staticClass: "text-box adorn-bottom"
  }, [_vm._v("\n        Es el\n          "), _c('strong', [_vm._v("dinero recibido")]), _vm._v(" por una persona. Puede provenir de diferentes fuentes como\n          "), _c('strong', [_vm._v("salarios, comisiones, ingresos por renta, intereses")]), _vm._v(", entre otros.\n          "), _c('br'), _c('br'), _vm._v("\n          Las familias pueden recibir uno, dos o más ingresos. Estos además pueden ser\n          "), _c('strong', [_vm._v("fijos")]), _vm._v(" o\n          "), _c('strong', [_vm._v("variables")]), _vm._v(".\n      ")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55e444c3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/screens/00-davivienda/davivienda-19.vue
// module id = 989
// module chunks = 1